<template>
    <div class="kfIcon">
        <a href="https://work.weixin.qq.com/kfid/kfcec2a443502d2dae4">
            <img src="https://res.diveboss.net/boatres/website/kficon.png" />
        </a>
    </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
    }
  },

  created() {

  },
  methods: {

  }
}
</script>
<style scoped>
.kfIcon {
    position: fixed;
    right: 1em;
    bottom: 3.2em;
    width: 3.2em;
    height: 3.2em;
    z-index: 100;
}
    .kfIcon img {
        width: 100%;
    }
</style>
